import React, { ReactElement } from "react";
import styled from "styled-components";
import IconSvg from "~/guidelines/Icon/IconSvg";
import { body2 } from "~/guidelines/Typography";

const StyledListItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
`;

const IconContainer = styled.div`
  width: ${({ theme }) => theme.spacing(6)};
  height: ${({ theme }) => theme.spacing(6)};
  flex: 0 0 auto;
  color: ${({ theme }) => theme.color.text.lightFirst};
`;

const ChildrenContainer = styled.div`
  flex: 1 1 auto;
  ${body2};
  color: ${({ theme }) => theme.color.text.lightThird};
`;

export type ListItemWithIconProps = {
  icon: ReactElement<typeof IconSvg>;
  children: React.ReactNode;
};

const ListItemWithIcon = ({ icon, children }: ListItemWithIconProps) => {
  return (
    <StyledListItem>
      <IconContainer>{icon}</IconContainer>
      <ChildrenContainer>{children}</ChildrenContainer>
    </StyledListItem>
  );
};

export default ListItemWithIcon;
